export default {
  init: function init() {
    //gradient video positioning
    function gradientPosition() {
      var headerHeight = $("#header").height() + parseFloat($('#header').css('padding-top')) + parseFloat($('#header').css('padding-bottom'));
      $('#banner .gradient-background').css('top', '-' + headerHeight + 'px');
    }

    gradientPosition();
    $(window).on('resize', function () {
      gradientPosition();
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/activation-kit-detail.js